import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { Spinner } from '@wartek-id/spinner'
import { useToast } from '@wartek-id/toast'

import { useAPIPelaksanaanProgress } from 'api/kinerja/useAPIKinerja'
import useDemoContext from 'app/KinerjaPage/hooks/useDemoContext'

import type { TStatePelaksanaan } from 'types/kinerja-pelaksanaan'

type PageGuardPelaksanaanProps = {
  pageState: TStatePelaksanaan
  ptkId?: string
  children?: React.ReactElement
}

/**
 * @deprecated
 *
 * Use PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS from app/KinerjaShared/constants/pelaksanaanSteps instead
 */
export const PELAKSANAAN_STEPS: Record<TStatePelaksanaan, number> = {
  DOCUMENT_PREPARATION: 1,
  OBSERVATION_IMPLEMENTATION: 2,
  DOCUMENT_FOLLOW_UP: 3,
  FOLLOW_UP_EVALUATION: 4,
  DOCUMENT_REFLECTION_FOLLOW_UP: 5,
  REFLECTION_FOLLOW_UP_EVALUATION: 6,
  COMPLETED: 7,
}

export function PageGuardPelaksanaan({
  pageState,
  children,
  ptkId,
}: React.PropsWithChildren<PageGuardPelaksanaanProps>) {
  const router = useRouter()
  const toast = useToast()
  const { isDemoMode } = useDemoContext()

  const { data, isLoading } = useAPIPelaksanaanProgress({
    ptkId,
    opts: {
      staleTime: 60 * 60 * 1000, // 1 hour
    },
    isDemoMode,
  })

  const whitelistAppeal: TStatePelaksanaan[] = ['OBSERVATION_IMPLEMENTATION']

  const pageStateNumber = PELAKSANAAN_STEPS[pageState] ?? Infinity
  const currentStateNumber = PELAKSANAAN_STEPS[data?.data?.state] ?? 0
  const hasAccess = currentStateNumber >= pageStateNumber
  const alreadyDone = currentStateNumber > pageStateNumber
  const hasAppeal =
    data?.data?.appealState && !whitelistAppeal.includes(pageState)
  const guruHasAppeal = !ptkId && hasAppeal && !alreadyDone

  useEffect(() => {
    if (!isLoading) {
      if (!hasAccess) {
        toast({ message: 'Selesaikan tahap sebelumnya.' })
      }
      if (guruHasAppeal) {
        toast({
          message:
            'Pengajuan perubahan harus diselesaikan terlebih dahulu. Mohon kabari atasan. ',
        })
      }

      if (!hasAccess || guruHasAppeal) {
        router.replace('/pengelolaan-kinerja')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAccess, isLoading, hasAppeal])

  if (isLoading || !hasAccess) {
    return (
      <div className="bg-gray-10 min-h-full flex pt-20 justify-center">
        <Spinner />
      </div>
    )
  }

  return children
}
